<template>
  <nav aria-label="Study stages" class="study-steps">
    <ol aria-label="Task progress">
      <li v-for="(step, index) in steps" :key="step.label" :aria-current="index === active ? 'step' : undefined" :class="{ done: index < current, active: index === active }">
        <RouterLink v-if="step.to" :to="step.to" :aria-label="step.label">
          <span class="study-step-number" aria-hidden="true">{{ index < current ? '✓' : index + 1 }}</span>{{ step.label }}
        </RouterLink>
        <span v-else class="study-step-disabled" :aria-label="`${step.label}, not yet available`">
          <span class="study-step-number" aria-hidden="true">{{ index + 1 }}</span>{{ step.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>
<script setup>
import { computed } from 'vue'
const props = defineProps({ participant: { type: Object, required: true }, reviewing: Boolean, reviewStage: String })
const stages = ['pre_questionnaire', 'pre_sample', 'writing', 'post_questionnaire', 'post_self', 'post_sample', 'complete']
const labels = ['Pre-questionnaire', 'Sample assessment', 'Writing', 'AI feedback experience', 'Self-assessment', 'Sample reassessment', 'Complete']
const current = computed(() => stages.indexOf(props.participant.stage))
const active = computed(() => props.reviewStage ? stages.indexOf(props.reviewStage) : props.reviewing ? 0 : current.value)
const steps = computed(() => {
  const p = props.participant, flow = `/student/experiments/${p.id}`
  return stages.map((stage, index) => ({label: labels[index], to: index === current.value ? stage === 'writing' ? `/student/task/${p.assignment_id}/workspace` : flow : index < current.value && p.review_stages?.includes(stage) ? `${flow}?review=${stage}` : null}))
})
</script>
<style scoped>
.study-steps { margin: 0 0 24px; }
ol { display: grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap: 4px; list-style: none; padding: 5px; margin: 0; border: 1px solid var(--border); background: var(--surface-muted); border-radius: 12px; }
li { min-width: 0; border-radius: 8px; color: var(--ink-muted); font-size: 14px; font-weight: 600; }
a, .study-step-disabled { display: flex; align-items: center; gap: 10px; padding: 12px; color: inherit; text-decoration: none; min-height: 46px; box-sizing: border-box; }
.study-step-number { display: inline-grid; place-items: center; width: 24px; height: 24px; border: 1px solid var(--border); border-radius: 50%; font-size: 12px; flex-shrink: 0; }
.active { background: var(--surface); color: var(--accent-strong); box-shadow: 0 1px 4px color-mix(in srgb, var(--ink) 8%, transparent); }
.active .study-step-number { color: white; background: var(--accent); border-color: var(--accent); }
.done:not(.active) .study-step-number { color: var(--accent-strong); }
a:hover { color: var(--accent-strong); background: var(--accent-soft); border-radius: 8px; }
a:focus-visible { outline: 3px solid var(--accent); outline-offset: 2px; border-radius: 8px; }
.study-step-disabled { opacity: .65; }
@media(max-width:600px) { ol { grid-template-columns: repeat(2,minmax(0,1fr)); } a,.study-step-disabled { font-size: 13px; padding: 10px; } }
</style>
